import { useCallback, useEffect, useRef } from "react";
import { v4 as uuid } from "uuid";
import { syncTranslation } from "@lookiero/i18n";
import { useCommand } from "@lookiero/messaging-react";
const useSyncTranslationForLocale = ({ locale, contextId, }) => {
    const localeRef = useRef(undefined);
    const syncedLocalesRef = useRef(new Set());
    const [commandBus, status] = useCommand({ contextId });
    const sync = useCallback(async () => {
        try {
            await commandBus(syncTranslation({ aggregateId: uuid(), locale }));
            syncedLocalesRef.current.add(locale);
        }
        catch (error) {
            console.error(error);
        }
    }, [locale, commandBus]);
    useEffect(() => {
        if (locale && localeRef.current !== locale) {
            sync();
            localeRef.current = locale;
        }
    }, [locale, sync]);
    const isLocaleSynced = useCallback((candidate) => syncedLocalesRef.current.has(candidate), []);
    return { status, isLocaleSynced };
};
export { useSyncTranslationForLocale };
